

export class ArgumentNotSuppliedError extends Error {
	constructor(argumentName: string) {
		super(`Value must be supplied. Parameters name: ${argumentName}`);
	}
}

export class UnreachableCaseError extends Error {
	constructor(val: never) {
		super(`Unreachable case: ${JSON.stringify(val)}`);
	}
}

export function never(val: never): never {
	throw new UnreachableCaseError(val);
}

export function logNever(val: never): void {
	console.error(`Unreachable case: `, val);
}
